import { BALRareStreamData } from "../../types";

const parseStringToBoolean = (value: string) => value === 'true' ? true : false;
const setTobAirDeviation = (air: string | number, tob: string | number) => {
    if (air === undefined || tob === undefined || typeof air === 'string' || typeof tob === 'string') {
        return '-'
    }
    const deviation = tob - air
    const deviationFixed = deviation.toFixed(2);
    return deviation < 0 ? `${deviationFixed}` : `+${deviationFixed}`
}
export const setDataByParams = (data: BALRareStreamData) => {
    const newData = data ? data : {};
    const airTempPV = newData.AirTempPV;
    const tobTempPV = newData.TobTempPV;
    const isBreakdown = newData.IsBreakdown;
    const isHistSampling = newData.IsHistSampling;
    return ({
        finalOutputFanSpeed: newData.FinalOutputFanSpeed,
        historianFanSpeed: newData.HistorianFanSpeed,
        airTempAverage: newData.AirTempAverage,
        tobTempAverage: newData.TobTempAverage,
        tobAirDeviation: setTobAirDeviation(airTempPV, tobTempPV),
        airTobaccoTemperatureSP: newData.AirTobaccoTemperatureSP,
        isHistSampling: newData.IsHistSampling,
        ...(isHistSampling) && { isHistSampling: parseStringToBoolean(isHistSampling) },
        ...(isBreakdown) && { isBreakdown: parseStringToBoolean(isBreakdown) },
    });
};

const paramListToIgnoreParsing = ['Solution', 'Line', 'isBreakdown', 'IsHistSampling'];

export const parseBALData = (data: BALRareStreamData) => {
    return Object.entries(data).reduce((acc, [key, val]: [string, string]) => {
        if (paramListToIgnoreParsing.includes(key)) {
            return Object.assign(acc, { [key]: val })
        }
        return Object.assign(acc, { [key]: val === '-' || val === '' ? '-' : parseFloat(val) });
    }, {} as BALRareStreamData)
}

export const parseSingleBALmsg = (el: BALRareStreamData) => {
    return ({
        [el.Line]: {
            [el.Solution]: setDataByParams(el)
        }
    })
}